<div class="row breadcrumbs-view-wrapper">
  <div class="col-md-12 breadcrumb-text-area rdt-container">
    <ng-container *ngIf="!isFullScreenMap">
      <ng-container *ngFor="let  item of breadcrumbsArray; let i = index;">
        <i *ngIf="i!=0" class="fa fa-angle-right breadcrumb-separator" aria-hidden="true"></i>
        <span class="breadcrumb-item" [ngClass]="{'breadcrumb-item-hand-cursor': item?.route}"
          (click)="navigateTo(item,i)">{{item?.displayValue}} </span>
      </ng-container>
    </ng-container>


    <img class="mapStyle" *ngIf="mapIconVis" pTooltip="Map View" tooltipPosition="bottom" (click)="goToMap()" src="assets/images/svg/fleets/icon_map.svg.svg">
    <span id="bellBtn" [style.display]="bellIconVis ? '' : 'none'" class="p-overlay-badge p-mr-5 bellStyle">
      <img class="curStyle" src="assets/images/svg/fleets/icon_bell.svg" (click)="handleViewnotification()">
      <span class="p-badge curStyle" (click)="handleViewnotification()">{{ newsCount }}</span>
    </span>
    <div id="notificationModal" [style.display]="notificationVis ? '' : 'none'">
      <div class="notificationTitle">
        Notification
        <div>show read
          <p-inputSwitch class="p-inputSwitch-lg" (onChange)="onSwitchChange($event)"></p-inputSwitch>
          <i class="pi pi-ellipsis-v curStyle" style="margin: 0 15px;" (click)="showButtonModal()"></i>
          <div id="buttonModal" [style.display]="buttonModalVis ? '' : 'none'">
            <p (click)="handleNotiAction('Read')">Mark All as Read</p>
            <p (click)="handleNotiAction('Unread')">Mark All as Unread</p>
            <p (click)="handleNotiAction('Notifications')">Open Notifications</p>
          </div>
        </div>
      </div>
      <div *ngFor="let news of newsList; let i = index;" class="notificationContent">
        <div class="content1">
          <span *ngIf="news.status === 'N' || news.status === 'UNREAD'" class="warning"></span>
          <span *ngIf="news.status === 'PROCESSED' || news.status === 'READ_NOT_P'" class="normal"></span>
          {{ news.truckId }}
          <i class="pi pi-ellipsis-v curStyle itemActionIcon" style="float: right; margin: 10px 30px 0 0;"
            (click)="handleItemActionVis(news,false)"></i>
          <div class="itemActionModal" [style.display]="news.showFlag? '' : 'none'">
            <p (click)="handleItemActionClick('Unwatch', news)">UnWatch</p>
            <p (click)="handleItemActionClick('Resolve', news)">Resolve</p>
            <p (click)="handleItemActionClick('Read', news)" style="border-top: 1px solid #ddd;">Mark as Read</p>
            <p (click)="handleItemActionClick('Detail', news)">View Detail</p>
            <p (click)="handleItemActionClick('Notification', news)" style="color: #9f9898;">Delet Notification</p>
          </div>
        </div>
        <div class="content2">
          {{ news.messageText }}
          <!-- <p class="speedLimit">
            <img src="assets/images/svg/fleets/icon_bell.svg" style="margin: 0 5px;">65 kph
          </p> -->
        </div>
        <div class="content3">
          {{ news.timestamp }}
          <!-- <img class="watchStyle"  *ngIf="news.status === 'N' || news.status === 'UNREAD'" src="assets/images/svg/fleets/icon_notification_watch.svg"> -->
          <img class="watchStyle" *ngIf="news.status === 'READ_NOT_P'"
            src="assets/images/svg/fleets/icon_notification_watch_status.svg">
          <!-- <img class="watchStyle"  *ngIf="news.status === 'PROCESSED'" src="assets/images/svg/fleets/icon_notification_resolve_status.svg"></div> -->
        </div>
      </div>
    </div>
    <p-dialog header="Remark" [(visible)]="displayDialog" [modal]="false" [style]="{width: '30vw', height: '200px'}">
      <div>
        <textarea pInputTextarea [(ngModel)]="remark"></textarea>
      </div>
      <div>
        <span class="submitBtn" (click)="submit()">submit</span>
      </div>
    </p-dialog>
  </div>